module.exports = __webpack_public_path__ + "static/media/OrvarOpenFinal2026.1d4946d7.jpg";